import {
    LOGIN_REQUEST,
    LOGIN_FAIL,
    LOGIN_SUCCESS,
    REGISTER_USER_REQUEST,
    REGISTER_USER_SUCCESS,
    REGISTER_USER_FAIL,
    LOAD_USER_REQUEST,
    LOAD_USER_SUCCESS,
    LOAD_USER_FAIL,
    LOGOUT_SUCCESS,
    LOGOUT_FAIL,
    UPDATE_PROFILE_REQUEST,
    UPDATE_PROFILE_SUCCESS,
    UPDATE_PROFILE_FAIL,
   
    CLEAR_ERRORS,
   
  } from "../constants/userConstants";
  import {
    doc,
    setDoc,
    addDoc,
    collection,
    where,
    query,
    getDoc,
    onSnapshot
  } from "firebase/firestore";
  import { RecaptchaVerifier, signInWithPhoneNumber, signInWithEmailAndPassword } from "firebase/auth";
  import { auth, db } from "../firebase.config";
  import { useNavigate } from "react-router-dom";
  import { getAuth, signOut } from "firebase/auth";
  
 
   
  
 
  export const loginUsingEmail = (email,password) => async (dispatch) => {
      try{
       dispatch({ type: LOGIN_REQUEST });
       signInWithEmailAndPassword(auth, email, password)
    .then((userCredential) => {
      // Signed in 
      const user = userCredential.user;
      dispatch({ type:LOGIN_SUCCESS, payload: user.uid });
      // ...
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
       console.log(error.message)
       dispatch({
        type: LOGIN_FAIL,
        payload: error.message,
      });
     
    });
      }
      catch (err){
           dispatch({
        type: LOGIN_FAIL,
        payload: err.message,
      });
      }
  }
  
  
  
  
  export const loadUser = (uid) => async (dispatch) =>{
    try{
      dispatch({ type: LOAD_USER_REQUEST });
      const userRef = doc(db, "user", uid);
      // const userSnap = await getDoc(userRef);
     
  const userData = await onSnapshot(doc(db, "user", uid), (doc) => {
      console.log("Current data: ", doc.data());
      dispatch({ type: LOAD_USER_SUCCESS, payload: doc.data()  });
  });
  console.log(userData)
  
  
  
  
    } catch(error){
       dispatch({ type: LOAD_USER_FAIL, payload: error.message });
    }
  }
  
  export const logout = () => async (dispatch) => {
      try {
      signOut(auth).then(() => {
        console.log("user logged out")
  }).catch((error) => {
      console.log(error.message)
  });
  
      dispatch({ type: LOGOUT_SUCCESS });
    } catch (error) {
      dispatch({ type: LOGOUT_FAIL, payload: error.message });
     
    }
  }
  
 
  
  
  export const clearErrors = () => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
  };
  
  